import { Button, Col, Form } from 'react-bootstrap';
import '../../../css/NewUser.css'
import Select from 'react-select'
import axiosInstance from '../../../axiosInstance';
import { logOut, make_select_data } from '../../helper';
import { Link, withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import axios from 'axios';
class NewUser extends Component {
    constructor() {
        super();
        this.state = {
            username: "",
            password: "",
            selected_role: null,
            roles_array: [],
            errors: {
                username: false,
                password: false,
                role: false,
            },
            modal: false,
            error_messages: {
                username_error_message: 'გთხოვთ შეიყვანოთ მომხმარებლის სახელი',
                password_error_message: 'გთხოვთ შეიყვანოთ მომხმარებლის პაროლი',
                role_error_message: 'გთხოვთ აირჩიოთ  როლი',
            },
            response: {
                isValid: false,
                isInValid: false,
                message: 'მომხმარებელი წარმატებით ჩაემატა'
            }
        }
    }
    onChange(event) {
        this.setState(
            {
                [event.target.name]: event.target.value,
                errors: {
                    ...this.state.errors,
                    [event.target.name]: false
                },
                response: {
                    isValid: false,
                    isInValid: false,
                    message: 'მომხმარებელი წარმატებით ჩაემატა'
                }
            }
        )
    }


    componentDidMount() {
        this.fetch_roles();
        let user_id = this.props.match.params.id
        if (user_id) {
            this.fetch_user(user_id)
        }
    }


    fetch_user(id) {
        axiosInstance.get('/users/' + id)
            .then(response => {
                console.log(response);
                this.setState({
                    username: response.data.data.username,
                    selected_role: {
                        value: response.data.data.role.id,
                        label: response.data.data.role.display_name
                    }
                })
            }).catch(error => {

            })
    }

    fetch_roles() {
        axiosInstance.get('/roles/auth/hierarchy')
            .then(response => {
                this.setState({
                    roles_array: make_select_data(response.data.data)
                })
            })
            .catch(err => {
                if (err.response.status === 401) {
                    logOut(this.props);
                }
            })
    }

    on_fetch_roles(data) {
        var roles_array = [];
        data.forEach(function (element) {
            roles_array.push({
                value: element.id,
                label: element.name
            })
        });

        this.setState({
            roles_array: roles_array
        });
    }



    on_bad_request(error) {
        this.setState({
            response: {
                ...this.state.response,
                isInValid: true,
                message: error.response.data.message
            }
        })
    }

    add_user_btn_clicked() {
        this.setState({
            response: {
                ...this.state.response,
                isInValid: false,
                isValid: false,
                message: ''
            }
        })
        if (this.valid()) {
            axiosInstance.post('/register', {
                "username": this.state.username,
                "password": this.state.password,
                "role_id": this.state.selected_role.value
            })
                .then(response => {
                    console.log(response);
                    this.setState({
                        response: {
                            ...this.state.response,
                            isValid: true,
                            message: response.data.message
                        }
                    })
                })
                .catch(error => {
                    if (error.response.status == 400) {
                        this.on_bad_request(error);
                    }
                });
        }
    }

    update_user_btn_clicked() {
        this.setState({
            response: {
                isInValid:false,
                isValid: false,
                message: ''
            }
        })
        axiosInstance.put('/users', {
            user_id: this.props.match.params.id,
            role_id: this.state.selected_role.value
        })
            .then(response => {
                this.setState({
                    response: {
                        ...this.state.response,
                        isValid: true,
                        message: response.data.message
                    }
                })
            }).catch(error => {
                if(error.response?.status == 403 || error.response?.status ==503 || error.response?.status == 422){
                    this.on_bad_request(error);
                }
            })
    }

    valid() {
        var username = (this.state.username === '');
        var password = (this.state.password === '');
        var role_id = (this.state.selected_role === null)
        if (username || password || role_id) {
            this.setState({
                errors: {
                    username: username,
                    password: password,
                    role: role_id,
                },
            })
            return false;
        }
        return true;
    }

    on_role_change(e) {
        console.log(e);
        this.setState({
            selected_role: e,
            errors: {
                ... this.state.errors,
                role: false,
            },
            response: {
                isValid: false,
                isInValid: false,
                message: 'მომხმარებელი წარმატებით ჩაემატა'
            }
        })
    }
    render() {
        return (
            <div className="content-main">
                <Form.Row>
                    <Form.Group as={Col} md="4" >
                        <Form.Control
                            type="text"
                            name="role"
                            hidden={true}
                            isInvalid={Boolean(this.state.response.isInValid)}
                            isValid={Boolean(this.state.response.isValid)}
                            onChange={null}
                        />
                        <Form.Control.Feedback type="invalid" >
                            {this.state.response.message}
                        </Form.Control.Feedback>

                        <Form.Control.Feedback >
                            {this.state.response.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} md="4" >
                        <Form.Label>Username</Form.Label>
                        <Form.Control
                            type="text"
                            name="username"
                            onChange={(event) => this.onChange(event)}
                            isInvalid={Boolean(this.state.errors.username)}
                            value={this.state.username}
                            disabled={this.props.match.params.id}
                        />
                        <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.username_error_message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                {!this.props.match.params.id && <Form.Row>
                    <Form.Group as={Col} md="4" >
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            onChange={(event) => this.onChange(event)}
                            isInvalid={Boolean(this.state.errors.password)}
                            value={this.state.password}
                        />
                        <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.password_error_message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                }
                <Form.Row>
                    <Form.Group as={Col} md="4" >
                        <Form.Control
                            type="text"
                            name="role"
                            hidden={true}
                            isInvalid={Boolean(this.state.errors.role)}
                            onChange={null}
                        />
                        <Select
                            value={this.state.selected_role}
                            options={this.state.roles_array}
                            onChange={(e) => this.on_role_change(e)} placeholder="აირჩიეთ როლი" />
                        <Form.Control.Feedback type="invalid" >
                            {this.state.error_messages.role_error_message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>

                <Link to="/users" id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                {this.props.match.params.id && <Button className="btn btn-success" size="md" onClick={(event) => this.update_user_btn_clicked(event)}>რედაქტირება</Button>}
                {!this.props.match.params.id && <Button className="btn btn-success" size="md" onClick={(event) => this.add_user_btn_clicked(event)}>დამატება</Button>}


            </div>
        )
    }
}
export default withRouter(NewUser);